import { useEffect } from "react"
import { createReferralConversion } from "@requests/referralConversions"

interface UseReferralConversionParams {
  convertibleType: string
  convertibleId:   string | number | undefined
  conversionType?: string
}

export function useReferralConversion({
  convertibleType,
  convertibleId,
  conversionType = "page_view",
}: UseReferralConversionParams): void {
  useEffect(() => {
    if (!convertibleId) return
    createReferralConversion({
      convertible_type: convertibleType,
      convertible_id:   convertibleId,
      conversion_type:  conversionType,
    }).catch(() => {})
  }, [convertibleId])
}
